<template>
  <el-dialog
    title="打印"
    :visible.sync="dialogPrintVisible"
    append-to-body
    @closed="closePrint"
    v-if="visiblePrint"
  >
    <!-- <el-select v-model="printId" placeholder="请选择" @change="choosePrint" style="margin-bottom: 20px">
      <el-option v-for="item in printList" :key="item.id"
        :label="`${item.name} (${item.paperWidth}mm*${item.paperHeight}mm)`" :value="item.id">
      </el-option>
    </el-select> -->
    <div class="printTitle">
      <!-- <div>分条卷带货架 (80mm*40mm)</div> -->
      <el-select v-model="printId" placeholder="请选择" @change="choosePrint" style="margin-bottom: 20px">
        <el-option v-for="item in printList" :key="item.id"
          :label="`${item.name} (${item.paperWidth}mm*${item.paperHeight}mm)`" :value="item.id">
        </el-option>
      </el-select>

      <el-button type="primary" style="margin-left: 50px" @click="printbatch"
        >打印</el-button
      >
    </div>
    <div id="printAll">
      <div
        v-for="(item, index) in printDataList"
        :key="index"
        :id="'warehousePrintItem' + index"
        class="font"
        :style="`width: ${paperWidth}mm ;height: ${paperHeight}mm;page-break-after: always; display: flex; align-items: center; justify-content: center`"
      >
        <div
          :style="`width: ${paperWidth-2}mm ;height: ${paperHeight}mm;margin: 0 auto; box-sizing: border-box;border-radius: 8px;`"
        >
          <table style="width: 100%; border-collapse: collapse;">
            <tr style="border-bottom: 1px solid #333">
              <td class="tableHeadTd" :style="`width: ${paperWidth*0.3}mm ;`">
                <div class="headname" :style="`font-size: ${paperHeight*0.06}mm;line-height: ${paperHeight*0.09}mm`">客户</div>
                <div :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">client</div>
              </td>
              <td class="tableContent">{{ item.code }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #333">
              <td class="tableHeadTd" :style="`width: ${paperWidth*0.3}mm ;`">
                <div class="headname" :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">型号</div>
                <div :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">model</div>
              </td>
              <td class="tableContent">{{ item.model }}</td>
            </tr>
            <tr style="border-bottom: 1px solid #333">
              <td class="tableHeadTd" :style="`width: ${paperWidth*0.3}mm ;`">
                <div class="headname" :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">规格</div>
                <div :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">spec</div>
              </td>
              <td class="tableContent">
                {{ item.specification }} 
              </td>
            </tr>
            <tr style="border-bottom: 1px solid #333">
              <td class="tableHeadTd" :style="`width: ${paperWidth*0.3}mm ;`">
                <div class="headname" :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">数量</div>
                <div :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">quantity</div>
              </td>
              <td class="tableContent">{{ item.quantity }}</td>
            </tr>
            <tr>
              <td class="tableHeadTd" :style="`width: ${paperWidth*0.3}mm ;`">
                <div class="headname" :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">日期</div>
                <div :style="`font-size: ${paperHeight*0.06}mm ;line-height: ${paperHeight*0.09}mm`">date</div>
              </td>
              <td class="tableContent">{{ item.date }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { selectAllPrintList } from "@/api/storeCodePrint.js";
import { fetchWarehouseList } from "@/api/storeWarehouse.js";
import print from "vue-print-nb";
import { codeUrl } from "@/utils/constant";

export default {
  directives: { print },
  data() {
    return {
      codeUrl: codeUrl,
      barcode_option: {
        displayValue: false,
      },
      userInfo: "",
      companyName: "",
      codeWidth: 50,
      classHeight: 6,
      list: [],
      dialogPrintVisible: false,
      printId: "",
      printList: [],
      paperWidth: 70,
      paperHeight: 30,
      printDataList: [],
      isAll: false,
      printData: {},
      visiblePrint: false,
      marginsWidth: 6,
      marginsHeight: 4,
    };
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("info"));
    this.userInfo = userInfo;
    if (this.userInfo.companyList) {
      this.companyName = this.userInfo.companyList[0].companyName;
    }
  },
  mounted() {
    this.getAllPrint();
  },
  methods: {
    init(data, type) {
      let printData = type == 'all' ? data : [data];
      this.printDataList = printData.map((item) => ({
        model: item.model,
        specification: item.specName,
        quantity: item.num,
        date: this.formatDate(item.createTime),
        code: item.code,
      }));
      this.initSize();
      this.dialogPrintVisible = true;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}.${month}.${day}`;
    },
    initSize() {
      this.codeWidth = parseInt((this.paperWidth - this.marginsWidth) * 0.8);
      if (this.codeWidth > (this.paperHeight - this.marginsHeight) * 0.8) {
        this.codeWidth = parseInt(
          (this.paperHeight - this.marginsHeight) * 0.8
        );
      }
    },
    choosePrint() {
      let fe = this.printList.filter((item) => {
        return item.id == this.printId;
      });
      if (fe) {
        this.paperWidth = fe[0].paperWidth;
        this.paperHeight = fe[0].paperHeight;
      }
      this.initSize();
    },
    getAllPrint() {
      selectAllPrintList().then((res) => {
        this.printList = res.data;
        if (this.printList && this.printList.length > 0) {
          this.printId = this.printList[0].id;
          this.choosePrint();
        }
      });
    },
    printbatch() {
      const printStyle = `<style>@media print{body{margin: 0px; padding: 0;}}
      @page {
        size: auto;
        margin: 0mm;
      }

      table td {
        white-space: nowrap;
        padding: 0;
        /* 防止文本换行 */
      }

      tr {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      /* 新增样式以匹配图片中的样式 */
      #warehousePrintItem div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }

      #warehousePrintItem table {
        width: 100%;
        border-collapse: collapse;
      }

      #warehousePrintItem tr {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      #warehousePrintItem td {
        padding: 2mm;
        font-size: 4mm;
        white-space: nowrap;
      }

      #warehousePrintItem td:first-child {
        text-align: right;
        font-weight: bold;
      }

      #warehousePrintItem td:last-child {
        padding-left: 5mm;
      }
      .printTitle {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;
        font-weight: 700;
        font-size: 16px;
      }
      .tableHeadTd {
        text-align: center;
        border-right: 1px solid #333;
      }
      .headname {
        border-bottom: 1px solid #333;
      }
      .tableContent {
        text-align: center;
        flex: 1;
      }
        .font {
 font-family: 'PingFang SC', Helvetica, arial, STHeiTi, sans-serif;
}
      </style>`;

      var newWin = window.open("");
      var printContainer = document.createElement("div");
      printContainer.style.width = `60mm`;
      printContainer.style.height = `40mm`;

      for (var i = 0; i < this.printDataList.length; i++) {
        var imageToPrint = document.getElementById("warehousePrintItem" + i);
        var clone = imageToPrint.cloneNode(true);
        printContainer.appendChild(clone);
      }

      newWin.document.write(printStyle + printContainer.outerHTML);
      newWin.document.close();
      newWin.focus();
      setTimeout(function () {
        newWin.print();
        newWin.close();
      }, 100);
    },
    closePrint() {
      this.visiblePrint = false;
    },
  },
};
</script>

<style scoped>
@page {
  size: auto;
  margin: 0mm;
}

table td {
  white-space: nowrap;
  padding: 0;
  /* 防止文本换行 */
}

tr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/* 新增样式以匹配图片中的样式 */
#warehousePrintItem div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#warehousePrintItem table {
  width: 100%;
  border-collapse: collapse;
}

#warehousePrintItem tr {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

#warehousePrintItem td {
  padding: 2mm;
  font-size: 4mm;
  white-space: nowrap;
}

#warehousePrintItem td:first-child {
  text-align: right;
  font-weight: bold;
}

#warehousePrintItem td:last-child {
  padding-left: 5mm;
}
.printTitle {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
  font-weight: 700;
  font-size: 16px;
}
.tableHeadTd {
  text-align: center;
  border-right: 1px solid #333;
}
.headname {
  border-bottom: 1px solid #333;
}
.tableContent {
  text-align: center;
  flex: 1;
}
.tableWidth {
  width: 90mm;
  height: 60mm;
}
/deep/ .el-dialog__body {
  height: 600px !important;
}
.font {
 font-family: 'PingFang SC', Helvetica, arial, STHeiTi, sans-serif;
}
</style>
